import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const IrGeneratorActions = createActionGroup({
  source: 'IR Generator',
  events: {
    'Add Query': emptyProps(),
    'Generate IR': props<{ id: number; prompt: string }>(),
    'Generate IR Success': props<{ id: number; response: string }>(),
    'Generate IR Failure': props<{ id: number; error: string }>(),
    'Reset State': emptyProps(),
  },
});
